"use strict";

var Backbone        = require("backbone");
var _               = require("underscore");

/**
 * UserModel
 */
module.exports = Backbone.Model.extend({
  
    defaults: {
        id:0,
        name:null,
        admin:false,
        premium:false,
        pro:false,
        bnf:false
    },

    /**
     * @param  {Object} attributes must contain "publicationId" and "id"
     * @param  {Object} options must contain "rnapi"
     */
    initialize: function (attributes, options) {
        _.extend(this, options);
    },

    isLoggedIn:function(){
        return this.get("id")?true:false;
    },

    isAdmin:function(){
        if(this.isLoggedIn() && this.get("admin")){
            return true;
        }
        else{
            return false;
        }
    },

    
    isPremium:function(){
        if(this.get("premium")){// on peut être premium sans être logué, dans le cas ezproxy par exemple
            return true;
        }
        else{
            return false;
        }
    },

    isPro:function(){
        if(this.isLoggedIn() && this.get("pro")){
            return true;
        }
        else{
            return false;
        }
    },

    isBnf:function(){
        if(this.isLoggedIn() && this.get("bnf")){
            return true;
        }
        else{
            return false;
        }
    }

});